import React, {memo, useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton} from '@mui/material'
import SaveStatus from '../SaveStatus';
import UniField from './UniField';
import mapStateToProps from './mapStateToProps';
import CloseSvg from "../../icons/CloseSvg";
import useStyles from './useStyles';

export const dialogTypes = {
    DEFAULT: 'modalDialogDefault',
    DELETE: 'modalDialogDelete'
}

const buildField = (vals, fields) => {
    if (!fields) return {}
    return fields.reduce((rezObj, {name, type, isId}, i) => {
        if (name) {
            if (vals?.[i] !== undefined && vals?.[i] !== null) {
                rezObj[name] = vals[i];
            } else if (isId) {
                rezObj[name] = undefined;
            } else if (type === "String") {
                rezObj[name] = '';
            } else if (type === "color") {
                rezObj[name] = '#ffed00';
            } else if (type === "icon") {
                rezObj[name] = 0;
            } else if (type === "Int") {
                rezObj[name] = 0;
            } else if (type === "Float") {
                rezObj[name] = 0;
            } else if (type === "Timestamp") {
                rezObj[name] = (new Date()).valueOf();
            } else if (type === "Timezone") {
                rezObj[name] = (new Date()).getTimezoneOffset() * (-60);
            } else if (type === "Enum") {
                rezObj[name] = '';
            } else if (type === "Boolean") {
                rezObj[name] = false;
            } else if (type === "Dir") {
                rezObj[name] = undefined;
            } else if (type === "Password") {
                rezObj[name] = '';
            }
        }
        return rezObj
    }, {})
}

function ModalDialog(props) {
    const {
        onClose,
        update = () => {
        },
        okText = 'Ok',
        saver = () => {
        },
        dictId,
        progressObj,
        itemIndex,
        title = "Подтвердите",
        formFieldsValues,
        formFields,
        open,
        className,
        type = dialogTypes.DEFAULT

        // ...other
    } = props;

    const classes = useStyles();
    const {
        updateShortDirectory = () => {
        },
    } = useSelector(mapStateToProps)

    const isNoFormDialog = (itemIndex !== undefined)

    const [
        /**Объединенное значение формы */
        values,
        /**обновить значение формы */
        setValues
    ] = useState(isNoFormDialog ? itemIndex : (buildField(formFieldsValues, formFields)))

    useEffect(() => {
        if (!isNoFormDialog) {
            setValues(buildField(formFieldsValues, formFields))
        }
    }, [formFieldsValues, formFields, isNoFormDialog])

    const onFormChange = (fieldName, newValue) => {
        const newFormState = {...values};
        // для поля ИНН !!!
        if (fieldName === 'tin') {
            // Удаляем все нецифровые символы из значения
            newFormState[fieldName] = newValue.replace(/\D/g, '');
        } else {
            newFormState[fieldName] = newValue;
        }
        setValues(newFormState)
    }

    const handleCancel = () => {
        onClose();
    };

    const handleOk = () => {
        saver(values)
        // onClose();
    };
    const postSave = () => {
        update()
        updateShortDirectory(dictId)
        onClose()
    }

    return (
        <Dialog
            sx={{'& .MuiDialog-paper': {width: '80%', maxHeight: "80%"}}}
            maxWidth="xs"
            open={open}
            className={`
                  ${classes.modalDialog}
                  ${className ? classes[className] : ''}
                  ${type ? classes[type] : ''}
                 `}
        >
            <DialogTitle className={classes.title}>{title}</DialogTitle>
            <IconButton
                onClick={handleCancel}
                className={classes.closeIcon}
            >
                <CloseSvg/>
            </IconButton>
            <DialogContent className={classes.content}>
                <SaveStatus dataObj={progressObj} successShowTime={500} errShowTime={6000}
                            postSuccessAction={postSave}/>
                {isNoFormDialog ? null : formFields.map((item, i) => {
                    const {name} = item;
                    return <UniField {...item} value={values?.[name]} onChange={(v) => onFormChange(name, v)}/>
                })}
            </DialogContent>
            <DialogActions className={classes.actions}>
                <Button
                    className={classes.saveBtn}
                    onClick={handleOk}
                    variant="contained"
                >
                    {okText}
                </Button>
            </DialogActions>
        </Dialog>

    );
}

export default memo(ModalDialog);
